import ColorLensIcon from '@material-ui/icons/ColorLens'
export const ConceptsIcon = ColorLensIcon
